<button (click)="onButtonClick()"
        [anatomicMapTooltip]="buttonConfig?.tooltipDescription ? (getTranslationLabel(buttonConfig?.btnType) | translate: {p0: buttonConfig?.tooltipDescription!}) : '' "
        [disabled]="disabled"
        [ngClass]="{'disabled': disabled}"
        class="map-legend-button material-icons map-legend-button--colorized">
    <div class="button-icon">
        {{ buttonConfig?.btnType === 'type2' ? 'check_box' : 'library_add_check' }}
    </div>
    <div [style]="'color:' + buttonConfig?.color" class="button-shadow"></div>
</button>
